// services/functions/inviteLicenseOrgMember.ts — typed wrapper
// around the invite-mint callable. Returns the accept URL once;
// the page renders it in a copy-now dialog and the server never
// echoes it again.

import { httpsCallable } from 'firebase/functions';
import { functions } from '@/services/firebase';

interface Input {
  licenseOrgId: string;
  productId: string;
  expiresInDays: number;
  note?: string;
}

interface Output {
  inviteId: string;
  acceptUrl: string;
  expiresAt: string;
}

const callable = httpsCallable<Input, Output>(
  functions,
  'inviteLicenseOrgMember',
);

export async function inviteLicenseOrgMember(input: Input): Promise<Output> {
  const res = await callable(input);
  return res.data;
}
